import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

interface UseIsWebviewProps {
  initialIsWebview?: boolean;
}

export function useIsWebview({ initialIsWebview = false }: UseIsWebviewProps = {}) {
  const router = useRouter();
  const [isWebview, setIsWebview] = useState(initialIsWebview);

  useEffect(() => {
    if (!('type' in router.query)) {
      return;
    }
    setIsWebview(router.query.type === 'app' && !!window.ReactNativeWebView);
  }, [router.query]);

  return isWebview;
}
